module.exports = __webpack_public_path__ + "static/media/dSlider3.ae7c7854.png";